import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
export type UserTooltipInfoFragment = { status: Types.UserStatusEnum, createdAt: string, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null };


export type UserTooltipInfoFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserTooltipInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment UserTooltipInfo on UserType {
  ...User
  status
  orgRole {
    id
    name
  }
  createdAt
}
    `;